@if (!high) {
    <svg [attr.height]="height"
         [attr.width]="width"
         fill="none"
         style="overflow: visible"
         viewBox="0 3 42 44"
         xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="25" fill="white" r="21"/>
        <circle cx="21" cy="25" fill="#FF5B5B" r="19"/>
        <path d="M9 25H14L17 17L21 33L25 25H33"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.4"/>
    </svg>
} @else {
    <svg [attr.height]="height"
         [attr.width]="width"
         fill="none"
         style="overflow: visible"
         viewBox="0 3 42 44"
         xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="25" fill="white" r="21"/>
        <circle cx="21" cy="25" fill="#FF9900" r="19"/>
        <path d="M9 25H14L17 17L21 33L25 25H33"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.4"/>
    </svg>
}
